import React, { useState, useEffect } from 'react';
//@ts-ignore
import * as carouselStyles from './carousel.module.css';
import { RelatedProductsProps } from './index';
import ProductTile from './ProductTile';
import ArrowLgButton from '../Global/ArrowLgButton';

//@ts-ignore
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { ProductPagePreview } from '../Global/DataUtils/productQueries';

interface Props extends RelatedProductsProps {
    selectedProducts: ProductPagePreview[];
}

const Carousel: React.FC<Props> = ({
    selectedProducts,
    background_color,
    cta_type,
    ...props
}) => {
    const breakpoints = useBreakpoint();

    const currentDisplayNumber = breakpoints.l ? 3 : 1;
    const [visibleProducts, setVisibleProducts] = useState(
        selectedProducts?.slice(0, currentDisplayNumber)
    );
    const arrowStrokeColor = '#505251';

    const [currentPage, setCurrentPage] = useState(0);
    const numProducts = selectedProducts?.length;

    useEffect(() => {
        setVisibleProducts(selectedProducts?.slice(0, currentDisplayNumber));
    }, [currentDisplayNumber]);

    const handlePrevClick = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        let newPage = currentPage - 1;
        let newCurrentProduct = newPage * currentDisplayNumber;

        let newVisibleProducts = selectedProducts?.slice(
            newCurrentProduct,
            newCurrentProduct + currentDisplayNumber
        );

        setCurrentPage(newPage);
        setVisibleProducts(newVisibleProducts);
    };

    const handleNextClick = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        let newPage = currentPage + 1;
        let newCurrentProduct = newPage * currentDisplayNumber;
        let newVisibleProducts = selectedProducts?.slice(
            newCurrentProduct,
            newCurrentProduct + currentDisplayNumber
        );

        setCurrentPage(newPage);
        setVisibleProducts(newVisibleProducts);
    };

    const renderProduct = (product: ProductPagePreview, idx: number) => {
        if (breakpoints.l || product === visibleProducts[0]) {
            return (
                <ProductTile
                    key={idx}
                    product={product}
                    productStyle={carouselStyles.product}
                    ctaStyle={carouselStyles.ctaContainer}
                    truncateLines={4}
                    productCtaLabel={
                        props.product_cta_label.value || 'View Product'
                    }
                />
            );
        }
    };

    return (
        <div className={carouselStyles.controls}>
            <div className={carouselStyles.carouselContainer}>
                {visibleProducts.map((product, idx) => {
                    return renderProduct(product, idx);
                })}
            </div>
            {currentPage != 0 && (
                <ArrowLgButton
                    direction="left"
                    strokeColor={arrowStrokeColor}
                    handleClick={handlePrevClick}
                    className={carouselStyles.prev}
                />
            )}
            {currentPage * currentDisplayNumber + currentDisplayNumber <
                numProducts && (
                <ArrowLgButton
                    direction="right"
                    strokeColor={arrowStrokeColor}
                    handleClick={handleNextClick}
                    className={carouselStyles.next}
                />
            )}
        </div>
    );
};

export default Carousel;
